import { QueryClient } from '@tanstack/react-query';

/**
 * Single app-wide QueryClient instance, extracted from App.tsx so it can
 * also be imported by useAuth.ts without creating a circular dependency
 * (App.tsx -> useAuth.ts -> App.tsx).
 *
 * useAuth.ts calls queryClient.clear() whenever the authenticated identity
 * (entityId+userId) changes, to prevent cross-tenant cache bleed between
 * sign-out/sign-in in the same tab. See useAuth.ts for details.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});
